var TopicSelector = require('../../selectors/topic-selector');

var FetchRequest = require('services/fetch/fetch-request');
var SubscriptionNotification = require('services/subscription-notification/subscription-notification');
var UnsubscriptionNotification = require('services/unsubscription-notification/unsubscription-notification');

var GetTopicDetails = require('services/get-topic-details/get-topic-details');

var AddTopic = require('services/add-topic/add-topic');
var RemoveTopic = require('services/remove-topic/remove-topic');
var UpdateTopicRequest = require('services/update-topic/update-topic-request');
var UpdateTopicSetRequest = require('services/update-topic/update-topic-set-request');
var UpdateTopicDeltaRequest = require('services/update-topic/update-topic-delta-request');
var UpdateTopicResponse = require('services/update-topic/update-topic-response');

var ClientSubscribeRequest = require('services/control-client/client-subscribe-request');
var ClientFilterSubscribeRequest = require('services/control-client/client-filter-subscribe-request');
var ClientFilterSubscribeResponse = require('services/control-client/client-filter-subscribe-response');

var SecurityCommandScript = require('services/authentication/security-command-script');
var SecurityCommandScriptResult = require('services/authentication/security-command-script-result');

var SecurityConfiguration = require('../../features/security').SecurityConfiguration;
var SystemAuthenticationConfiguration = require('../../features/security').SystemAuthenticationConfiguration;

var TopicWillParameters = require('services/wills/topic-will-parameters');
var WillRegistrationResult = require('services/wills/will-registration-result');

var SendRequest = require('services/send/send-request');
var SessionSendRequest = require('services/send/session-send-request');

var TopicControlRegistrationRequest = require('services/control/topic-control-registration-request');
var TopicControlRegistrationParams = require('services/control/topic-control-registration-params');

var UpdateSourceRegistrationRequest = require('services/topic-update/update-source-registration-request');
var UpdateSourceDeregistrationRequest = require('services/topic-update/update-source-deregistration-request');
var UpdateSourceUpdate = require('services/topic-update/update-source-update');
var UpdateSourceSetRequest = require('services/topic-update/update-source-set-request');
var UpdateSourceDeltaRequest = require('services/topic-update/update-source-delta-request');
var UpdateSourceUpdateResponse = require('services/topic-update/update-source-update-response');
var UpdateSourceStateRequest = require('services/topic-update/update-source-state-request');
var UpdateSourceState = require('services/topic-update/update-source-state');
var ControlRegistrationRequest = require('services/control/control-registration-request');
var ControlRegistrationParams = require('services/control/control-registration-params');

var ChangePrincipalRequest = require('services/change-principal/change-principal-request');

var SessionForwardSendRequest = require('services/send/session-forward-send-request');
var MessageReceiverControlRegistrationRequest =
        require('services/control/message-receiver-control-registration-request');
var MessageReceiverControlRegistrationParams =
        require('services/control/message-receiver-control-registration-params');

var FilterSendRequest = require('services/send/filter-send-request');
var FilterSendResult = require('services/send/filter-send-result');

var GetSessionProperties = require('services/control/get-session-properties');
var SetSessionPropertiesListener = require('services/control/set-session-properties-listener');
var SessionPropertiesEvent = require('services/control/session-properties-event');
var SessionPropertiesEventBatch = require('services/control/session-properties-event-batch');

var MissingTopicRequest = require('services/missing-topic/missing-topic-request');

module.exports = {
    FETCH : {
        id : 2,
        name : "Fetch",
        request : FetchRequest,
        response : null
    },
    SUBSCRIBE : {
        id :  3,
        name : "Subscribe",
        request : TopicSelector,
        response : null
    },
    UNSUBSCRIBE : {
        id : 4,
        name : "Unsubscribe",
        request : TopicSelector,
        response : null
    },
    SUBSCRIBE_CLIENT : {
        id : 10,
        name : "Subscribe session",
        request : ClientSubscribeRequest,
        response : null
    },
    UNSUBSCRIBE_CLIENT : {
        id : 11,
        name : "Unsubscribe session",
        request : ClientSubscribeRequest,
        response : null
    },
    SEND : {
        id : 6,
        name : "Send",
        request : SendRequest,
        response : null
    }, 
    SEND_TO_SESSION : {
        id : 28,
        name : "Send to session",
        request : SessionSendRequest,
        response : null
    },
    SUBSCRIPTION_NOTIFICATION : {
        id : 40,
        name : "Subscription Notification",
        request : SubscriptionNotification,
        response : null
    },
    GET_TOPIC_DETAILS : {
        id : 41,
        name : "Get Topic Details",
        request : GetTopicDetails,
        response : GetTopicDetails
    },
    UNSUBSCRIPTION_NOTIFICATION : {
        id : 42,
        name : "Unsubscription Notification",
        request : UnsubscriptionNotification,
        response : null
    },
    ADD_TOPIC : {
        id : 46,
        name : "Add Topic",
        request : AddTopic,
        response : AddTopic
    },
    REMOVE_TOPIC : {
        id : 47,
        name : "Remove Topic",
        request : RemoveTopic,
        response : null
    },
    MISSING_TOPIC : {
        id : 50,
        name : "Missing topic",
        request : MissingTopicRequest,
        response : Boolean
    },
    TOPIC_SCOPED_WILL_REGISTRATION : {
        id : 53,
        name : "Topic Will Registration",
        request : TopicWillParameters,
        response : WillRegistrationResult
    },
    TOPIC_SCOPED_WILL_DEREGISTRATION : {
        id : 54,
        name : "Topic Will Deregistration",
        request : TopicWillParameters,
        response : null
    },
    SYSTEM_PING : {
        id : 55,
        name : "System Ping",
        request : null,
        response : null
    },
    USER_PING : {
        id : 56,
        name : "User Ping",
        request : null,
        response : null
    },
    CHANGE_PRINCIPAL : {
        id : 5,
        name : "Change Principal",
        request : ChangePrincipalRequest,
        response : Boolean
    },  
    GET_SYSTEM_AUTHENTICATION : {
        id : 57,
        name : "Get System Authentication",
        request : null,
        response : SystemAuthenticationConfiguration 
    },
    UPDATE_SYSTEM_AUTHENTICATION : {
        id : 58,
        name : "Update System Authentication",
        request : SecurityCommandScript,
        response : SecurityCommandScriptResult
    },
    GET_SECURITY_CONFIGURATION : {
        id : 59,
        name : "Get Security Configuration",
        request : null,
        response : SecurityConfiguration
    },
    UPDATE_SECURITY_CONFIGURATION : {
        id : 60,
        name : "Update Security Configuration",
        request : SecurityCommandScript,
        response : SecurityCommandScriptResult
    },
    UPDATE_TOPIC : {
        id : 61,
        name : "Update Topic",
        request : UpdateTopicRequest,
        response : UpdateTopicResponse
    },
    SERVER_CONTROL_REGISTRATION : {
        id : 18,
        name : "Server Control Registration",
        request : ControlRegistrationRequest,
        response : null
    },
    SERVER_CONTROL_DEREGISTRATION : {
        id : 19,
        name : "Server Control Deregistration",
        request : ControlRegistrationParams,
        response : null
    },
    TOPIC_CONTROL_REGISTRATION : {
        id : 20,
        name : "Topic Control Registration",
        request : TopicControlRegistrationRequest,
        response : null
    },
    TOPIC_CONTROL_DEREGISTRATION : {
        id : 21, 
        name : "Topic Control Deregistration",
        request : TopicControlRegistrationParams,
        response : null
    },
    UPDATE_SOURCE_REGISTRATION : {
        id : 30,
        name : "Update Source Registration",
        request : UpdateSourceRegistrationRequest,
        response : UpdateSourceState
    },
    UPDATE_SOURCE_DEREGISTRATION : {
        id : 31,
        name : "Update Source Deregistration",
        request : UpdateSourceDeregistrationRequest,
        response : null
    },
    UPDATE_SOURCE_STATE : {
        id : 32,
        name : "Update Source State",
        request : UpdateSourceStateRequest,
        response : null
    },
    UPDATE_SOURCE_UPDATE : {
        id : 35,
        name : "Update Source Update",
        request : UpdateSourceUpdate,
        response : UpdateSourceUpdateResponse 
    },
    SEND_RECEIVER_CLIENT : {
        id : 62,
        name : "Control Client Send Service",
        request : SessionForwardSendRequest,
        response : null
    },
    MESSAGE_RECEIVER_CONTROL_REGISTRATION : {
        id : 63,
        name : "Message Receiver Control Registration",
        request : MessageReceiverControlRegistrationRequest,
        response : null
    },
    MESSAGE_RECEIVER_CONTROL_DEREGISTRATION : {
        id : 64,
        name : "Message Receiver Control Deregistration",
        request : MessageReceiverControlRegistrationParams,
        response : null
    },
    FILTER_SUBSCRIBE : {
        id : 65,
        name : "Subscribe to filter",
        request : ClientFilterSubscribeRequest,
        response : ClientFilterSubscribeResponse
    },
    FILTER_UNSUBSCRIBE : {
        id : 66,
        name : "Unsubscribe from filter",
        request : ClientFilterSubscribeRequest,
        response : ClientFilterSubscribeResponse
    },
    SEND_TO_FILTER : {
        id : 29,
        name : "Send to filter",
        request : FilterSendRequest,
        response : FilterSendResult
    },
    GET_SESSION_PROPERTIES : {
        id : 67,
        name : "Get session properties",
        request : GetSessionProperties,
        response : GetSessionProperties
    },
    SESSION_PROPERTIES_REGISTRATION : {
        id : 69,
        name : "Set session properties listener - legacy, see SESSION_PROPERTIES_REGISTRATION_2",
        request : SetSessionPropertiesListener,
        response : null 
    },
    SESSION_PROPERTIES_EVENT : {
        id : 70,
        name : "Session properties event - legacy, see SESSION_PROPERTIES_EVENT_2",
        request : SessionPropertiesEvent,
        response : null 
    },
    UPDATE_SOURCE_SET : {
        id : 77,
        name : "Update source set",
        request : UpdateSourceSetRequest,
        response : UpdateSourceUpdateResponse
    },
    UPDATE_SOURCE_DELTA : {
        id : 78,
        name : "Update source delta",
        request : UpdateSourceDeltaRequest,
        response : UpdateSourceUpdateResponse
    },
    UPDATE_TOPIC_SET : {
        id : 79,
        name : "Update topic set",
        request : UpdateTopicSetRequest,
        response : UpdateTopicResponse
    },
    UPDATE_TOPIC_DELTA : {
        id : 80,
        name : "Update topic delta",
        request : UpdateTopicDeltaRequest,
        response : UpdateTopicResponse
    },
    SESSION_PROPERTIES_REGISTRATION_2 : {
        id : 81,
        name : "Session Properties registration 2",
        request : SetSessionPropertiesListener,
        response : null
    },
    SESSION_PROPERTIES_EVENT_2 : {
        id : 82,
        name : "Session Properties event 2",
        request : SessionPropertiesEventBatch,
        response : null
    },
    TOPIC_REMOVAL : {
        id : 83,
        name : "Topic removal",
        request : RemoveTopic,
        response : null
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/services.js
// module id = 31
// module chunks = 1